// components/mdx/ImageBlock.jsx
"use client";
import Image from "next/image";

export default function ImageBlock({
    src,
    alt = "",
    caption = "",
    width = 800,
    height = 480,
    className = "",
    ...props
}) {
    if (!src) return null;

    return (
        <figure
            className={`my-6 flex flex-col items-center w-full ${className}`}
        >
            <div className="relative w-full overflow-hidden rounded shadow">
                <Image
                    src={src || "/placeholder-avatar.png"}
                    alt={alt}
                    width={width}
                    height={height}
                    sizes="(max-width: 768px) 100vw, 800px"
                    className="object-contain md:object-cover rounded max-w-full h-auto"
                    {...props}
                />
            </div>
            {(caption || alt) && (
                <figcaption className="text-xs text-gray-500 text-center mt-2">
                    {caption || alt}
                </figcaption>
            )}
        </figure>
    );
}
